<script>
    import PageHeader from '../components/page-header/page-header.vue';

    export default {
        components: { PageHeader }
    };
</script>

<template>
    <body>
        <page-header />

        Page not found

    </body>
</template>



// WEBPACK FOOTER //
// src/pages/not-found.vue?48542ffc